module.exports = __webpack_public_path__ + "img/banner.311b48f9.png";